import ReportList from './List';

export default {
  list: ReportList,
};
